import React, {useState} from 'react'
import { BsChevronDown } from 'react-icons/bs'
import './Action.css'

const Action = ({clickedval, actionsta}) => {
    const [view, setView] = useState(false)
    const [value, setValue] = useState('None')
    const handleClick = () =>{
        setView(!view)
    }

    const handleSelect = (e) =>{
        setValue(e.target.outerText)
        clickedval(e.target.outerText)
        setView(false)
    }
    
  return (
    <div className='action-main-container'>
        <div className='action-container' onClick={handleClick}>
            <BsChevronDown id='action-chevrondwn'/>
            <span>{value}</span>
        </div>
        {view && <div className='action-dropdwn-container'>
            <span id='action-dropdwn' onClick={e => handleSelect(e)}>None</span>
            <span id={actionsta ?  'action-dropdwn-disable' : 'action-dropdwn'} onClick={e => handleSelect(e)}>Reschedule</span>
            <span id={actionsta ?  'action-dropdwn-disable' : 'action-dropdwn'} onClick={e => handleSelect(e)}>Cancel</span>
        </div>}
    </div>
  )
}

export default Action